import {login, logout, info} from '../api/auth'
import { ElMessage } from 'element-plus';
import caches from './caches'
import router from './router'

const auth = {
	user: {},
	loginInfo: {
		username: undefined,
		password: undefined
	},
	verifyTh: undefined,
	init() {
		this.loginInfo = caches.loginInfo
		this.user = caches.userinfo
		this.verifyTh = setInterval(() => this.verify(), 4 * 60 * 1000)
	},
	verify() {
		return new Promise((resolve, reject) => {
			info().then(resp => {
				caches.userinfo = resp.data
				const loginInfo = JSON.parse(JSON.stringify(caches.loginInfo))
				loginInfo.token = resp.data.token
				caches.loginInfo = loginInfo
				this.user = resp.data
				resolve(resp.data)
			}).catch(() => {
				this.login().then(resp => {
					caches.userinfo = resp.data
					this.user = resp.data
					ElMessage({
						message: '自动登录成功！',
						type: 'success',
						duration: 5 * 1000
					})
					resolve(resp)
				}).catch(e => {
					ElMessage({
						message: '自动登录失败，请重新登录！',
						type: 'error',
						duration: 5 * 1000
					})
					router.to('login')
					reject(e)
				})
			})
		})
	},
	login(obj) {
		return new Promise((resolve, reject) => {
			if (obj && obj.username && obj.password && obj.phone) {
				caches.loginInfo = {
					username: obj.username,
					password: obj.password,
					phone: obj.phone,
				}
			}
			if (!obj) {
				obj = { type: 'token', token: caches.loginInfo.token, username: caches.loginInfo.username, password: caches.loginInfo.password, }
			}
			login(obj).then(resp => {
				caches.loginInfo = {
					username: obj.username,
					password: obj.password,
					phone: obj.phone,
					token: resp.data.token
				}
				caches.userinfo = resp.data
				resolve(resp)
			}).catch(e => {
				if (obj.type === 'token') {
					login({ ...obj, type: 'password' }).then(resp => {
						caches.loginInfo = {
							username: obj.username,
							password: obj.password,
							phone: obj.phone,
							token: resp.data.token
						}
						caches.userinfo = resp.data
						resolve(resp)
					}).catch(e => reject(e))
				}
				reject(e)
			})
		})
	},
	logout() {
		return new Promise((resolve, reject) => {
			logout().then(() => {
				for (const k of Object.keys(caches)) {
					caches[k] = undefined
				}
				resolve()
			}).catch(e => {
				reject(e)
			})
		})
	}
}

export default auth
